// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___CYgLf";
var _2 = "styles-module__description___eKDgL";
var _3 = "styles-module__title___Iw754";
export { _1 as "container", _2 as "description", _3 as "title" }
